<c-card>
    <c-card-header class="card-header" >
      <h4 class="card-header__heading">Average time at {{repairerName}} (Last 30 days)</h4>
    </c-card-header>
    <c-card-body>

        <div *ngIf="isLoading" style="display: flex; justify-content: center;">
            <c-spinner variant="grow" />
        </div>

        <table datatable class="table table-striped" *ngIf="vehicleRepairData.length > 0">
            <thead class="small-header">
                <tr>
                    <th>Registration</th>
                    <th>Model</th>
                    <!-- <th>Status</th>
                    <th>VOR Reason</th> -->
                    <th>Most Recent Entry Date</th>
                    <th>Most Recent Exit Date</th>
                    <th>Accumulated Time at Repairer</th>
                    <!-- <th>Notes</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let vehicle of vehicleRepairData">
                    <td>{{ vehicle.vehicle }}</td>
                    <td>{{ vehicle.manufacturer_model }}</td>
                    <!-- <td>{{ vehicle.status }}</td>
                    <td>{{ vehicle.vorReason }}</td> -->
                    <td>{{ vehicle.entry_and_exit_times[vehicle.entry_and_exit_times.length - 1][0] | date : 'medium' }} </td>
                    <td>{{ vehicle.entry_and_exit_times[vehicle.entry_and_exit_times.length - 1][1] | date : 'medium' }}</td>
                    <td>{{ vehicle.time_spent | secondToDaysHoursMinutes}}</td>
                    <!-- <td>{{ vehicle.notes }}</td> -->
                </tr>
            </tbody>
        </table>
        <div *ngIf="vehicleRepairData.length === 0 && !isLoading">
            <div><p>There is no data</p></div>
        </div>

    </c-card-body>
</c-card>
<!-- <c-smart-table [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="5"
[items]="vehicleRepairData" [tableProps]="{ hover: true, striped: true, responsive: true }"
activePage="1" header pagination /> -->

